<template>
    <div class="home-main-container">
        <!-- 경고 문구 -->
        <div v-if="showWarning" class="warning-message"> 
            <span class="icon">❗</span>
            시스템 사용은 모니터링, 기록 및 감사 대상이 될 수 있습니다.
            <button @click="showWarning = false" style="margin-left:auto;font-size:0.95em;color:#c82333;background:none;border:none;cursor:pointer;">닫기</button>
        </div>

        <div class="main-center">
            <div class="card-group">
                <div class="card" @click="goToRegister">
                    <img src="@/assets/resource/svg/register-icon.svg" alt="환자 등록" />
                    <div>환자 등록</div>
                </div>
                <div class="card" @click="goToList">
                    <img src="@/assets/resource/svg/list-icon.svg" alt="환자 목록" />
                    <div>환자 목록</div>
                </div>
            </div>
        </div>

        <div class="device-status" @click="toggleConnect">
            <div class="status-row header">
                <span class="bluetooth-icon"></span>
                <span class="status-label">장비 연결 상태</span>

                <!-- [MOD] 설정 아이콘 다시 쓰려면 아래처럼 버튼/아이콘을 살리고,
                     openDeviceSettings에서 bleActions로 호출 -->
                <!-- <span class="setting-icon" @click="openDeviceSettings($event)"></span> -->
            </div>

            <div v-if="!bleState?.deviceConnected?.value" class="status-row error">
                <span class="error-text">⚠️ 기기를 연결하려면 여기를 클릭하세요</span>
            </div>

            <div v-if="bleState?.deviceConnected?.value" class="status-row conn">
                <span class="conn-icon"></span>
                <span>{{ bleState.deviceName.value }}</span>
                <span class="ready-text">
                    {{ bleState.isReady.value ? '✅ 통신 준비 완료' : '⏳ 통신 준비 중' }}
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

// BLE 상태와 액션 주입
const bleState = inject('bleState')
const bleActions = inject('bleActions')

const showWarning = ref(true)
const router = useRouter()

const toggleConnect = () => {
    // [MOD] inject 실패 방지 가드 (provide 누락/초기 로딩 시)
    if (!bleState || !bleActions) {
        alert('BLE 초기화가 완료되지 않았습니다.')
        return
    }

    if (bleState.deviceConnected.value) {
        bleActions.disconnectDevice()
    } else {
        bleActions.connectDevice()
    }
}

function goToRegister() {
    router.push('/patientadd/patientadd')
}

function goToList() {
    router.push('/patientlist/patientlist')
}

function openDeviceSettings(event) {
    event.preventDefault()
    event.stopPropagation()

    // [MOD] 직접 Android.openBluetoothSettings() 호출하지 말고,
    // App.vue에서 제공한 bleActions를 통해 postMessage로 호출되게 변경
    if (!bleActions) {
        alert('블루투스 설정을 열 수 없습니다')
        return
    }

    // [MOD] Flutter 브릿지 존재 여부는 Android.postMessage 기반으로 체크하는 게 맞음
    const hasBridge =
        typeof window.Android !== 'undefined' &&
        typeof window.Android.postMessage === 'function'

    if (!hasBridge) {
        alert('블루투스 설정을 열 수 없습니다')
        return
    }

    // [MOD] App.vue에 openBluetoothSettings 액션을 추가해둔 경우 이렇게 호출
    // (아직 App.vue에 없다면, 아래 주석대로 추가하면 됨)
    if (typeof bleActions.openBluetoothSettings === 'function') {
        bleActions.openBluetoothSettings()
    } else {
        // fallback: 브릿지 직접 호출(권장 X)
        window.Android.postMessage(JSON.stringify({ type: 'openBluetoothSettings' }))
    }
}

// [MOD] Home에서 직접 네이티브 호출이 필요하면 App.vue의 bleActions에 액션을 추가하는 방식이 제일 깔끔함.
// 예: App.vue provide('bleActions', { ..., openBluetoothSettings: () => callNative('openBluetoothSettings') })

const PatientListFilter = {
    searchType: "all",
    searchText: "",
    startDate: "",
    endDate: "",
    sortOption: "recently"
}

onMounted(() => {
    if (!sessionStorage.getItem('hasShownLoginWarning')) {
        showWarning.value = true
        sessionStorage.setItem('hasShownLoginWarning', 'true')
    }
    sessionStorage.setItem('PatientListPage', '1')
    sessionStorage.setItem('PatientListFilter', JSON.stringify(PatientListFilter))
})
</script>
